import { IUserDetails } from "./getUserById";
import { apiClient } from "lib/apiClient";

export const getCurrentUser = async (id: string): Promise<IUserDetails> => {
  const response = await apiClient.get(`/users/authentication/${id}`);

  return response.data;
};
